import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import Swal from "sweetalert2";
import { RenderKilogramo } from "Utils/renderField/renderReadField";
import "react-step-progress-bar/styles.css";
import { TrasladosApi } from "../../api/TrasladosApi";
import {
    getMateriaPrimaFromDetalles,
    getVehiculoLabel,
} from "../../helpers/data";
import { groupProductosByMateriaPrima } from "../../helpers/groupProductos";
import { ProductosTable } from "./ProductosTable";
import LoadMask from "../../../../Utils/LoadMask/LoadMask";
import { getErrorFromResponse } from "../../../../../../utility/utils";
const logo_img = require("assets/img/logo.png");
const despachos_activo = require(`assets/img/icons/recepciones_activo.png`);
const linea_img = require("assets/img/icons/linea.png");

export const DatosBoleta = ({ trasladoId }) => {
    const fechaHoraImpresion = moment().format("DD/MM/YYYY HH:mm:ss");

    const { getTrasladoDetalle, cargando: cargandoDetalle } = TrasladosApi();

    const [trasladoDetalle, setTrasladoDetalle] = useState({});

    const GetTrasladoDetalle = async () => {
        try {
            const data = await getTrasladoDetalle(trasladoId);

            const groupedProductos = groupProductosByMateriaPrima(
                data.detalles,
            );
            const newData = { ...data, detalles: groupedProductos };

            setTrasladoDetalle(newData);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el detalle del traslado",
            );
            Swal.fire({
                title: "Error",
                text: errorMsg,
                type: "error",
            });
            setTrasladoDetalle({});
        }
    };

    useEffect(() => {
        GetTrasladoDetalle();
    }, [trasladoId]);

    if (cargandoDetalle) {
        return (
            <LoadMask loading={cargandoDetalle} blur>
                <div style={{ height: "400px" }}></div>
            </LoadMask>
        );
    }

    const tipoDeMateriaPrimaField = () => {
        if (!trasladoDetalle) return null;
        if (!trasladoDetalle.detalles || trasladoDetalle.detalles.length === 0)
            return null;

        const materiasPrimasUnicas = [
            ...new Set(
                trasladoDetalle.detalles.map(
                    (detalle) =>
                        detalle.materia_prima && detalle.materia_prima.nombre,
                ),
            ),
        ];

        if (materiasPrimasUnicas.length === 0) {
            return null;
        }

        if (materiasPrimasUnicas.length === 1) {
            return (
                <div className="col-12 d-flex flex-column">
                    <label className="p-0 m-0">TIPO DE MATERIA PRIMA</label>
                    <span className="gris">{materiasPrimasUnicas[0]}</span>
                </div>
            );
        }

        return (
            <div className="col-12 d-flex flex-column">
                <label className="p-0 m-0">TIPOS DE MATERIA PRIMA</label>
                <span className="gris">{materiasPrimasUnicas.join(", ")}</span>
            </div>
        );
    };

    return (
        <div className="col-12 p-0">
            <div className="row contenido-impresion verde-secundario d-flex justify-content-center">
                <div className="col-12 row">
                    <div className="col-12 d-flex justify-content-center mt-0 mb-3">
                        <div className="col-11 pl-2">
                            <div className="row col-12 p-0 mt-3 d-flex justify-content-between align-items-center">
                                <img
                                    className="d-inline-block align-top"
                                    src={logo_img}
                                    alt="Logo"
                                    height="50px"
                                />
                                <label className="p-0 m-0">
                                    ALDEA LAS PALMAS, COATEPEQUE
                                </label>
                                <div className="ml-4 mr-4"></div>
                            </div>
                        </div>
                    </div>
                    {/* DATOS TRASLADO */}
                    <div className="col-12 d-flex justify-content-center mt-0">
                        <div className="col-11">
                            <div className="row col-12 p-0 mt-2 justify-content-center align-items-start">
                                <div className="col-7 p-0 fondo">
                                    <div className="col-12 d-flex flex-column pl-0">
                                        <div className="d-flex align-items-center">
                                            <img
                                                src={despachos_activo}
                                                alt="Usuario"
                                                className="title_img mr-2"
                                            />
                                            <img
                                                src={linea_img}
                                                alt="Linea"
                                                className="title_img mr-2"
                                            />
                                            <h6 className="text-black mb-0">
                                                BOLETA DE TRASLADO
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-5 p-0">
                                    <div className="col-12 d-flex flex-column">
                                        <span className="gris">
                                            Fecha de impresión:
                                        </span>
                                        <span className="gris">
                                            {fechaHoraImpresion}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="row col-12 p-0 pt-1">
                                <div className="col-7 p-0">
                                    <div className="col-12 d-flex flex-column">
                                        <label className="p-0 m-0">
                                            ACOPIO ORIGEN
                                        </label>
                                        <span className="gris">
                                            {trasladoDetalle.acopio_origen
                                                ? trasladoDetalle.acopio_origen
                                                      .nombre
                                                : ""}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-5 p-0">
                                    <div className="col-12 d-flex align-items-baseline">
                                        <label className="p-0 m-0">
                                            NÚMERO DE TRASLADO
                                        </label>
                                        <h5 className="gris bold pl-2">
                                            {trasladoDetalle.numero}
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div className="row col-12 p-0 mt-2">
                                <div className="col-7 p-0">
                                    <div className="col-12 d-flex flex-column">
                                        <label className="p-0 m-0">
                                            VEHÍCULO
                                        </label>
                                        <span className="gris">
                                            {getVehiculoLabel(
                                                trasladoDetalle.vehiculo,
                                            )}
                                        </span>
                                    </div>
                                </div>
                                <div className="col-5 p-0">
                                    <div className="col-12 d-flex flex-column">
                                        <label className="p-0 m-0">
                                            PILOTO
                                        </label>
                                        <span className="gris">
                                            {trasladoDetalle.piloto
                                                ? trasladoDetalle.piloto.nombre
                                                : ""}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="row col-12 p-0 mt-2">
                                <div className="col-7 p-0">
                                    <div className="col-12 d-flex flex-column">
                                        <label className="p-0 m-0">
                                            PESO NETO SALIDA DEL ACOPIO
                                        </label>
                                        <span className="gris">
                                            <RenderKilogramo
                                                value={
                                                    trasladoDetalle.peso_salida
                                                }
                                            />
                                        </span>
                                    </div>
                                </div>
                                <div className="col-5 p-0">
                                    {tipoDeMateriaPrimaField()}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* OBSERVACIONES */}
                    <div
                        className="col-12 d-flex justify-content-center"
                        style={{ padding: "0 2rem" }}
                    >
                        <div className="col-11 form-group np-r p-0 mt-3 mb-1">
                            <div className="d-flex flex-column">
                                <label className="p-0 m-0">OBSERVACIONES</label>
                                <span className="gris">
                                    {trasladoDetalle.observaciones ||
                                        "Sin observaciones"}
                                </span>
                                {/* <textarea
                                    id="observaciones"
                                    className="form-control"
                                    rows={3}
                                    value={trasladoDetalle.observaciones}
                                    readOnly
                                    disabled
                                    style={{
                                        resize: "none",
                                        overflowY: "scroll",
                                    }}
                                /> */}
                            </div>
                        </div>
                    </div>
                    {/* TABLA DE PRODUCTOS */}
                    <div className="col-12 d-flex justify-content-center p-0">
                        <div className=" col-11 form-group np-r p-0 mt-3 mb-1">
                            {/* TABLA DE PRODUCTOS */}
                            <ProductosTable trasladoDetalle={trasladoDetalle} />
                        </div>
                    </div>
                    {/* FIRMAS */}
                    <div className="col-12 d-flex justify-content-center p-0">
                        <div className="col-11 form-group np-r p-0 mt-3 mb-5">
                            <div className="d-flex flex-1 justify-content-center mt-5 p-0 gap-2rem">
                                <div className="d-flex flex-column flex-1 align-items-center gap-2 no-gap-print">
                                    <input
                                        className="espacio-firma mb-1"
                                        type="text"
                                        readOnly
                                    />
                                    <label className="p-0 m-0 text-nowrap">
                                        FIRMA RESPONSABLE DEL ACOPIO
                                    </label>
                                </div>

                                <div className="d-flex flex-column flex-1 align-items-center gap-2 no-gap-print">
                                    <input
                                        className="espacio-firma mb-1"
                                        type="text"
                                        readOnly
                                    />
                                    <label className="p-0 m-0 text-nowrap">
                                        FIRMA TRANSPORTISTA RESPONSABLE
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
